const API = {
  //Admin Module API's
  COUNTRY: 'countries',
  CITY: 'cities',
  STATE: 'states',
  ACCOUNT: 'accounts',
  ACCOUNT_MANAGER: 'account-managers',
  CLUSTER: 'clusters',
  CURRENCY: 'currencies',
  USER: 'users',
  PRODUCTS: 'products',
  LOCATION: 'locations',
  JOB_FAMILY_ROLES: 'job-family-roles',
  MODULE: 'modules',
  ROLES: 'roles',
  OCCUPATION: 'occupation',
  SOURCE: 'source',
  PROFIT_PLAN: 'profit-plan',
  PRODUCT_CATEGORIES: 'categories',
  PRODUCT_SUB_CATEGORIES: 'sub-categories',
  PARTNER: 'partners',
  HOLIDAY: 'holidays',
  CONFIGURATION: 'configurations',
  DESIGNATION: 'designations',
  PERMISSION: 'permissions',
  ROLE: 'roles',
  EMPLOYMENTTYPE: 'employment-types',
  LEAVETYPE: 'leave-types',
  LEAVEPOLICY: 'leave-policies',
  LEAVECONFIGURATION: 'leave-configurations',
  LEAVEREQUEST: 'leave-requests',
  ATTENDENCE: 'attendances',
  LEAVEBALANCE: 'leave-balance',
  //Investment Module API
  PROSPECTS: 'prospect',
  COMMENTS: 'comment',
  // Associate-based RBAC endpoints
  USER_ASSOCIATE_STATUS: 'users/:id/associate-status', // GET user associate status
}

export default API
